export const TRIGGER_DATA_FETCHER = 'TRIGGER_DATA_FETCHER';

export function triggerDataFetcher({ force = false } = {}) {
    return {
        type: TRIGGER_DATA_FETCHER,
        force,
    };
}
